module.exports = __webpack_public_path__ + "img/full0-min.7c360f03.png";